var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5168 8.28306V12.4051C13.5168 13.5203 12.6213 14.4243 11.5168 14.4243H4.59772C3.49315 14.4243 2.59772 13.5203 2.59772 12.4051V8.28306H1.39192C1.23412 8.28306 1.1062 8.15391 1.1062 7.9946C1.1062 7.92249 1.13295 7.853 1.18118 7.79981L7.56195 0.76304C7.77506 0.528027 8.13651 0.511927 8.36929 0.727081C8.38131 0.738195 8.39286 0.749825 8.4039 0.761937L14.8185 7.79926C14.9254 7.91649 14.9179 8.09898 14.8018 8.20686C14.749 8.25586 14.68 8.28306 14.6083 8.28306H13.5168Z",
    stroke: "#D42E29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28564 14.1347H9.71422V11.2501C9.71422 10.2942 8.9467 9.51929 7.99993 9.51929C7.05316 9.51929 6.28564 10.2942 6.28564 11.2501V14.1347Z",
    stroke: "#D42E29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5168 8.28306V12.4051C13.5168 13.5203 12.6213 14.4243 11.5168 14.4243H4.59772C3.49315 14.4243 2.59772 13.5203 2.59772 12.4051V8.28306H1.39192C1.23412 8.28306 1.1062 8.15391 1.1062 7.9946C1.1062 7.92249 1.13295 7.853 1.18118 7.79981L7.56195 0.76304C7.77506 0.528027 8.13651 0.511927 8.36929 0.727081C8.38131 0.738195 8.39286 0.749825 8.4039 0.761937L14.8185 7.79926C14.9254 7.91649 14.9179 8.09898 14.8018 8.20686C14.749 8.25586 14.68 8.28306 14.6083 8.28306H13.5168Z",
    stroke: "#D42E29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28564 14.1347H9.71422V11.2501C9.71422 10.2942 8.9467 9.51929 7.99993 9.51929C7.05316 9.51929 6.28564 10.2942 6.28564 11.2501V14.1347Z",
    stroke: "#D42E29"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.21b5d34f.svg";
export { ForwardRef as ReactComponent };